import { useMemo, useState } from 'react'
// api
import {useActiveAlarms} from '../useActiveAlarms'
import {  AlarmDetailsDto, isAcknowledged } from '../../services/alarm'

interface UseNotAckedAlarmsOutput {
    count: number,
    items: AlarmDetailsDto[] | undefined,
    error: any,
    isLoading: boolean
}

function useNotAckedAlarms(): UseNotAckedAlarmsOutput {

    const { items: alarms, error, isLoading} = useActiveAlarms()

    const notAckedAlarms = useMemo(() => {
        const tmp = alarms?.slice()
        return tmp?.filter((a) => !isAcknowledged(a))
    }, [alarms]);


    return {
        count: notAckedAlarms?.length || 0,
        items: notAckedAlarms,
        error: error,
        isLoading: isLoading
    }
}

export default useNotAckedAlarms